import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { useSelector } from 'react-redux';

import axios from 'axios';

// import DeleteIcon from '@material-ui/icons/Delete';
import CallIcon from '@material-ui/icons/Call';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { CommonConfig } from '../../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     marginTop: theme.spacing(6),
    // },
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    formControlCall: {
        // margin: theme.spacing(2),
        minWidth: 500,
    },
    pl0: {
        padding: '0',
        '& span': {
            fontSize: '14px',
            fontFamily: 'Rubik',
        },
    },
    fontbold600: {
        '& span': {
            fontWeight: '600',
            textAlign: 'right',
        },
    },
}));
export default function RemarksDialog({ row, deleteRow, axiosConfig, tennantName }) {
    const buyerType = row.buyerType;
    const buyerId = row.buyerId;
    const [rows, setPendingInvoices] = useState([]);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [pendingClientDetails, setPendingClientDetails] = React.useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [clientInfo, setclientInfo] = React.useState('');
    // const [clientInfo, setclientInfo] = React.useState('');
    const callforclient = clientInfo.ClientInfo;
    const UserinfoCRC = clientInfo.Userinfo;
    const clientCall = callforclient && callforclient.primarycontMobnumber;
    const userinfoCall = UserinfoCRC && UserinfoCRC.mobileNumber;
    //console.log('Userinfocall', UserinfoCRC);
    //console.log('ClientcallInfo', callforclient);
    //console.log('response...', pendingClientDetails);
    //console.log('responseTennant', tennantName);
    //console.log('responsebuyerType', buyerType);
    //console.log('responsebuyerId', buyerId);
    //console.log('APIROW', row);
    //console.log(dataRow, openPopup, handlePopClose, 'PROPS FROM Open service');
    // const classes = useStyles();
    // const [open, setOpen] = React.useState(false);

    // const fetchClientDetails = () => {
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith`, {
    //             headers: {
    //                 Authorization: bearerToken,
    //             },
    //         })
    //         .then((response) => {
    //             ////console.log('response.Chandra', response.data.content);
    //             setPendingClientDetails(response.data.content);
    //         })
    //         .catch((error) => {});
    // };
    const handleClickOpen = () => {
        setOpen(true);
        //console.log('ChandraResponse : ', row);
        fetchClientDetails();
    };

    const handleClose = () => {
        setOpen(false);
    };
    const call = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/call?userPhone=${userinfoCall}&salesPhone=${clientCall}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log('THE CALL : ', response);
                if (response.data.message === 'Phone call incoming!') {
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };
    const fetchClientDetails = () => {
        // const apiUrl = `${CommonConfig.dev.baseUrl}/api/auth/call-info?userType=${buyerType}&id=${buyerId}&tennantName=${tennantName}`;
        // https://api.advithitec.in/api/auth/call-info?userType=Individual&id=300&tennantName=advith
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/call-info?userType=${buyerType}&id=${buyerId}&tennantName=${tennantName}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                //console.log('response71', response);
                setclientInfo(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    const handleOk = () => {
        deleteRow(row);
        setOpen(false);
    };
    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    // };
    // const handleOk = () => {
    //     deleteRow(row);
    //     setOpen(false);
    // };

    return (
        <>
            <Tooltip title="Call" onClick={handleClickOpen}>
                <IconButton aria-label="Call">
                    <CallIcon />
                </IconButton>
            </Tooltip>

            <Dialog
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
                // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Client Details
                </DialogTitle>
                <DialogContent>
                    {/* <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        Client ID:
                    </DialogContentText>
                    <TextField autoFocus margin="dense" id="name" label="Email Address" type="email" fullWidth /> */}
                    <Grid container className={classes.formControlCall}>
                        <Grid item xs={6} sm={6} className={classes.pl0}>
                            <List component="nav" aria-label="main mailbox folders">
                                <ListItem className={classes.pl0}>
                                    <ListItemText primary="Client ID:" />
                                    <div className={classes.fontbold600}>
                                        <ListItemText>{callforclient && callforclient.iclientId}</ListItemText>
                                    </div>
                                    {/* <ListItemText>{clientInfo.ClientInfo && clientInfo.ClientInfo.firstName}</ListItemText> */}
                                </ListItem>
                                <ListItem className={classes.pl0}>
                                    <ListItemText primary="Name:" />
                                    <ListItemText className={classes.fontbold600}>{callforclient && callforclient.firstName}</ListItemText>
                                </ListItem>
                                <ListItem className={classes.pl0}>
                                    <ListItemText primary="Service Type:" />
                                    <ListItemText className={classes.fontbold600}>{row.servicetypeId}</ListItemText>
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <List component="nav" aria-label="main mailbox folders">
                                <ListItem className={classes.pl0}>
                                    <ListItemText primary="Invoice No:" />

                                    <ListItemText className={classes.fontbold600}>{row.invoiceNumber}</ListItemText>
                                </ListItem>
                                <ListItem className={classes.pl0}>
                                    <ListItemText primary="Invoice Date:" />
                                    <ListItemText className={classes.fontbold600}>{row.invoiceDate}</ListItemText>
                                </ListItem>
                                <ListItem className={classes.pl0}>
                                    <ListItemText primary="Invoice Amount:" />
                                    <ListItemText className={classes.fontbold600}>{row.totalAmount}</ListItemText>
                                </ListItem>
                            </List>
                        </Grid>
                    </Grid>
                    <Divider />
                    {/* <Grid container>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" component="h6" className={classes.fontbold600}>
                                Update CRC Team Contact Number(If required)
                            </Typography>
                            <TextField
                                // id="relevence-remarks"
                                // multiline
                                // rows={5}
                                // placeholder="Called client no response"
                                InputProps={{
                                    classes: { root: classes.bottomLine },
                                }}
                                style={{ paddingTop: '15px' }}
                                // value={relevanceReview}
                                // onChange={handleTextChange}
                            />
                        </Grid>
                    </Grid> */}
                    <Divider />
                </DialogContent>
                <DialogActions className={classes.popFoot}>
                    <Button onClick={() => handleClose()} variant="outlined" color="primary" size="small" className={classes.button}>
                        Cancel
                    </Button>
                    <Button onClick={() => call()} variant="outlined" color="primary" size="small" className={classes.button} autoFocus>
                        Call
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
